import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import FormInput from '../../components/Global/Forms/FormInput';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';

// Utils
import {
  validateEmail,
} from '../../utils/helpers';


class AccountAdminsForm extends Component {

  state = {
    currentUserEmail: '',
    emails: [],
    formErrors: [],
    pendingAdminEmails: [],
    displayErrorMessages: false,
    formIsValid: false,
    formValuesChanged: false
  }

  componentWillReceiveProps(nextProps) {
    this.prepopulateForm(nextProps.adminEmails)
  }

  prepopulateForm(adminEmails) {
    let formErrorsArray = this.getInitialFormErrorsArray(adminEmails);

    let emailsThatAreNotCurrentUser = adminEmails.filter((email) => {
      return email !== this.props.user.email;
    });

    this.setState(state => ({
      ...state,
      currentUserEmail: this.props.user.email,
      emails: emailsThatAreNotCurrentUser,
      formErrors: formErrorsArray,
      initialAdmins: emailsThatAreNotCurrentUser ? emailsThatAreNotCurrentUser : null
    }))
  }

  getInitialFormErrorsArray(adminEmails) {
    let array = [];
    let length = adminEmails.length; // user defined length

    for (let i = 0; i < length; i++) {
      array.push('');
    }

    return array;
  }

  handleInputChange = (event, position) => {
    const { value } = event.target;
    const { initialAdmins } = this.state;

    let emailArray = [...this.state.emails];

    let newState = [
      ...emailArray.slice( 0, position ),
      value,
      ...emailArray.slice( position + 1, emailArray.length)
    ]

    this.setState(state => ({
      ...state,
      emails: newState,
      formValuesChanged: arraysEqual(initialAdmins, newState) ? false : true
    }), () => { this.updateFieldErrorMessage(value, position) });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { emails } = this.state;

    if (this.isFormValid()) {
      this.props.handleSubmit(emails);
    } else {
      this.setFormErrorState();
    }
  }

  setFormErrorState = () => {
    const { emails, displayErrorMessages } = this.state;

    emails.map((email, index) => {
      return this.updateFieldErrorMessage(email, index)
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  updateFieldErrorMessage = (emailValue, position) => {
    let formErrorArray = [...this.state.formErrors];
    let message = '';

    if (!validateEmail(emailValue)) {
      message = 'Please enter a valid email';
    } else {
      message = '';
    }

    let newFormErrors = [
      ...formErrorArray.slice( 0, position ),
      message,
      ...formErrorArray.slice( position + 1, formErrorArray.length)
    ]

    this.setState(state => ({
      ...state,
      formErrors: newFormErrors
    }))
  }

  isFormValid() {
    const { emails } = this.state;

    let inputErrorIndex = emails.map((email) => {
      return validateEmail(email)
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  addInput = () => {
    const { initialAdmins } = this.state
    let newEmails = [...this.state.emails];
    let newFormErrors = [...this.state.formErrors];

    newEmails.push('');
    newFormErrors.push('');

    this.setState(state => ({
      ...state,
      emails: newEmails,
      formErrors: newFormErrors,
      formValuesChanged: arraysEqual(initialAdmins, newEmails) ? false : true
    }))
  }

  removeInput = (position) => {
    const { initialAdmins } = this.state;
    let newEmails = [...this.state.emails];
    let newFormErrors = [...this.state.formErrors];

    newEmails.splice(position, 1);
    newFormErrors.splice(position, 1);

    this.setState(state => ({
      ...state,
      emails: newEmails,
      formErrors: newFormErrors,
      formValuesChanged: arraysEqual(initialAdmins, newEmails) ? false : true
    }))
  }

  render() {
    const {
      currentUserEmail,
      emails,
      formErrors,
      displayErrorMessages,
      formValuesChanged
    } = this.state;

    const { submitButtonText, isLoading } = this.props;

    return isLoading
    ? (
      <AppCanvasLoader />
    )
    : (
      <form
        onSubmit={this.handleSubmit}
        className="account-admins-form"
      >
        <label>Admin Email Addresses</label>
        <FormInput
          name="email"
          type="text"
          value={currentUserEmail + ' (you)'}
          disabled={true}
          onChange={this.handleInputChange}
        />
        {emails.map((email, index) => {
          return (
            <FormInput
              key={index}
              placeholder="Enter Email"
              name="email"
              type="text"
              value={email}
              onChange={(event) => this.handleInputChange(event, index)}
              onBlur={this.handleEmailInputBlur}
              showError={displayErrorMessages}
              errorMessage={formErrors[index]}
              handleInputRemoval={() => this.removeInput(index)}
            />
          )
        })}
        <a
          onClick={this.addInput}
          className="cta full-width"
        >
          + Add An Admin
        </a>
        { formValuesChanged && <hr /> }
        { formValuesChanged &&
          <input
            type="submit"
            className="cta-gradient"
            value={submitButtonText ? submitButtonText : 'Submit'}
            onClick={this.handleSubmit}
          />
        }
      </form>
    );
  }
}

function arraysEqual(arr1, arr2) {
  let array1 = [...arr1]
  let array2 = [...arr2]

  if (array1.length !== array2.length){
    return false;
  } else {
    array1.sort()
    array2.sort()
    for (var i = array1.length; i--;) {
      if(array1[i] !== array2[i])
        return false;
    }
  }
  return true;
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  null
)(AccountAdminsForm)



// WEBPACK FOOTER //
// ./src/components/Forms/AccountAdminsForm.js